import * as service from './service'
export default {
  namespace: 'customerServiceFaqDetail',
  state: {
    detailData: {
      title: '',
      content: ''
    }
  },
  effects: {
    * queryWebsiteDetailById ({ payload }, { call, put }) {
      const res = yield call(service.queryWebsiteDetailById, payload)
      yield put({
        type: 'save',
        payload: {
          detailData: res.data.data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
